export function displayDiscount(discount: number) {
  return `-${discount} %`;
}
